import {Button} from '@wandb/components';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {entryPointPlaceholders, WBAgentEntryPointButton} from '../../../aria';
import {CreateReportPrompt} from './../CreateReportPrompt/CreateReportPrompt';
import {
  EmptyContainer,
  EmptyHeader,
  EmptyHeaderActions,
  EmptyHeaderText,
} from './CreateReportPromptHeader.styles';

type CreateReportPromptHeaderProps = {
  entityName: string;
  projectName: string;
  onCreateReportPrompt: () => void;
  createReport: (msg: string) => void;
};

export const CreateReportPromptHeader = ({
  createReport,
  entityName,
  onCreateReportPrompt,
  projectName,
}: CreateReportPromptHeaderProps) => (
  <EmptyContainer>
    <EmptyHeader>
      <EmptyHeaderText>Reports</EmptyHeaderText>
      <TailwindContents>
        <EmptyHeaderActions>
          <WBAgentEntryPointButton
            data-dd-action-name="Create report with agent"
            data-test="ask-aria-report-button"
            entryPoint="reports_list"
            label="Draft report with ARIA"
            placeholder={entryPointPlaceholders.createReport}
          />
          <Button
            data-test={`create-report-button`}
            variant="primary"
            onPress={() => {
              createReport('empty reports tab');
            }}>
            Create report
          </Button>
        </EmptyHeaderActions>
      </TailwindContents>
    </EmptyHeader>
    <CreateReportPrompt
      location={`reports tab`}
      entityName={entityName}
      projectName={projectName}
      onCreateReport={onCreateReportPrompt}
    />
  </EmptyContainer>
);
